export const getDespesasText = (meta?: {
  despesas: number;
  fornecedores: Set<string>;
}) => {
  return `Listando ${meta?.despesas} ${
    meta?.despesas === 1 ? "despesa" : "despesas"
  } de ${meta?.fornecedores.size} ${
    meta?.fornecedores.size === 1 ? "fornecedor" : "fornecedores"
  }`;
};
